import { render, staticRenderFns } from "./CheckboxFavoritos.vue?vue&type=template&id=3ac02c51&scoped=true&"
import script from "./CheckboxFavoritos.vue?vue&type=script&lang=js&"
export * from "./CheckboxFavoritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac02c51",
  null
  
)

export default component.exports